import React from "react";
import { Modal } from "../../design-system";
import FeedbackForm from "../../app/feedback/FeedbackForm";

const FeedbackModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={Boolean(isOpen)}
      onClose={onClose}
      title="Feedback"
      size="lg"
      bodyMaxHeight="calc(100vh - 140px)"
    >
      <FeedbackForm showCard={false} situation="EDITOR_FEEDBACK_MODAL" />
    </Modal>
  );
};

export default FeedbackModal;

